














































































































































































import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel, DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import DeleteDialog from '@/components/DeleteDialog.vue'

interface EventFile extends Event {
  target: HTMLInputElement & EventTarget
}

interface ComponentData {
  tableHeight: string
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  loading: boolean
  saveLoading: boolean
  showDeleteDialog: boolean
  documentIndex: number
  selectedDocument: any | null
  isEdit: boolean
  rules: Function[]

  documentList: any[]

  gruppeList: any[]
  vorlageList: any[]
  employeeList: any[]

  isFilterGruppe: boolean
  filterGruppe: any | null
  isFilterVorlage: boolean
  filterVorlage: any | null
  isFilterAutor: boolean
  filterAutor: any | null
  allgemeine: string | null
  isAlleDokumente: boolean

  gruppe: any | null
  vorlage: any | null
  code: any | null
  bezeichnung: any | null
  datei: any | null
  selectedAuthor: any | null
  erstellungsdatum: any | null
  komentar: any | null

  link: any
}

export default Vue.extend({
  name: 'CommissionDocuments',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    DeleteDialog
  },

  props: {
    commissionId: Number
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      loading: false,
      saveLoading: false,
      showDeleteDialog: false,
      documentIndex: 0,
      selectedDocument: null,
      isEdit: false,
      rules: [(value: any): boolean | string => !!value || ''],

      documentList: [],

      gruppeList: [],
      vorlageList: [],
      employeeList: [],

      isFilterGruppe: false,
      filterGruppe: null,
      isFilterVorlage: false,
      filterVorlage: null,
      isFilterAutor: false,
      filterAutor: null,
      allgemeine: null,
      isAlleDokumente: false,

      gruppe: null,
      vorlage: null,
      code: null,
      bezeichnung: null,
      datei: null,
      selectedAuthor: null,
      erstellungsdatum: null,
      komentar: null,
      link: null
    }
  },

  watch: {
    commissionId (newVal: number): void {
      if(newVal) {
        this.fetchDocumentList()
      }
    },

    selectedDocument (newVal: any | null): void {
      const form: any = this.$refs['form']
      form.resetValidation()
      if(newVal) {
        this.isEdit = false
        this.setData()
      } else {
        this.setData()
      }
    },
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isDocumentBeforeDisabled(): boolean {
      return this.documentIndex === 0 || this.documentList.length === 0
    },

    isDocumentAfterDisabled(): boolean {
      return this.documentIndex === this.documentList.length -1 || this.documentList.length === 0
    },

    filteredDocumentList (): any[] {
      return this.documentList
    }
  },

  methods: {
    onAddDocumentClick (): void {
      this.selectedDocument = null
      this.isEdit = true

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    onEditDocumentClick (): void {
      this.isEdit = true

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    onDeleteDocumentClick (): void {
      this.showDeleteDialog = true
    },

    onDocumentBeforeClick (): void {
      this.documentIndex -= 1
      this.selectedDocument = this.documentList[this.documentIndex]
    },

    onDocumentAfterClick (): void {
      this.documentIndex += 1
      this.selectedDocument = this.documentList[this.documentIndex]
    },

    onUploadClick (): void {
      // @ts-ignore
      this.$refs.photoInput.click()
    },

    onDocumentChange (e: EventFile): void {
      if (e && e.target.files) {
        const file: File | undefined = e.target.files[0]

        if (file) {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = (e: any) => {
            if (e.target && e.target.result) {
              //let type: string = e.target.result.split('/')[1].split(';')[0]
              //let document = e.target.result.split(',')[1]
              //console.log(type)
              //console.log(document)
            }
          }

          /*let fileData = new Blob([file], { type: 'application/octet-stream' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(fileData)
          let filename = file.name
          link.download = filename
          link.click()
          this.link = link.href*/

        }
      }
    },

    onOpenClick (): void {
      //window.open("https://download.autodesk.com/us/samplefiles/acad/architectural_-_annotation_scaling_and_multileaders.dwg", "_blank", "target=_blank");
      //window.open(this.link, "_blank", "noopener noreferrer");
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {

    },

    onSaveButtonClick (): void {

    },

    onCancelClick (): void {
      this.isEdit = false
      if(!this.selectedDocument && this.documentList.length > 0) {
        this.documentIndex = 0
        this.selectedDocument = this.documentList[this.documentIndex]
      }
      this.setData()
    },

    onGetFileClick (): void {
      console.log('file')
    },

    onRowClick (rowData: any): void {
      this.selectedDocument = rowData.data
      this.documentIndex = this.documentList.indexOf(this.selectedDocument)
    },

    async fetchDocumentList (): Promise<void> {
      this.documentList = [
        {id: 1, bemerkungen: "Test1"},
        {id: 2, bemerkungen: "Test2"},
        {id: 3, bemerkungen: "Test3"},
        {id: 4, bemerkungen: "Test4"},
        {id: 5, bemerkungen: "Test5"},
        {id: 6, bemerkungen: "Test6"}
      ]
      if(this.documentList.length > 0 && !this.selectedDocument) {
        this.selectedDocument = this.documentList[this.documentIndex]
      }

      this.setData()
    },

    setData (): void {
      this.gruppe = this.selectedDocument ? this.selectedDocument.bemerkungen : null
      this.vorlage = this.selectedDocument ? this.selectedDocument.bemerkungen : null
      this.code = this.selectedDocument ? this.selectedDocument.bemerkungen : null
      this.bezeichnung = this.selectedDocument ? this.selectedDocument.bemerkungen : null
      this.datei = this.selectedDocument ? this.selectedDocument.bemerkungen : null
      this.selectedAuthor = this.selectedDocument ? this.selectedDocument.bemerkungen : null
      this.erstellungsdatum = this.selectedDocument ? this.selectedDocument.bemerkungen : null
      this.komentar = this.selectedDocument ? this.selectedDocument.bemerkungen : null

      if(this.documentList.length > 0 && this.selectedDocument) {
        //@ts-ignore
        setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.selectedDocument.id])}, 100)
      } else {
        //@ts-ignore
        setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)
      }
    },

    onResize (): void {
      if(this.$refs.formSection && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.formSection as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 232px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },
  },

  mounted () {
    setTimeout(() => { this.onResize() }, 0)
    this.fetchDocumentList()
  }

})
